import { SERVER } from "appConfig";

import { i18n } from "services/i18nService";
import {
  getTokenParams,
  setBearerToken,
} from "services/utility/authentication";

export async function updateTokens({
  email,
  password,
  accessToken,
  accessTokenSecret,
  loginResponse,
  selectedCompanyId,
  errorHandler,
  grantType,
}) {
  const tokenParams = getTokenParams(grantType, {
    email,
    password,
    accessToken,
    accessTokenSecret,
  });
  if (!tokenParams) {
    errorHandler(i18n("auth.Invalid"));
  }

  let tokens = {};
  const promises = loginResponse.companies.map(async ({ companyId }) => {
    const params = { ...tokenParams, scope: companyId };
    const body = Object.keys(params)
      .map((key) => key + "=" + encodeURIComponent(params[key]))
      .join("&");

    const response = await fetch(SERVER + "/oauth2/token", {
      method: "POST",
      body,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Host: SERVER,
      },
      credentials: "include",
    });
    const json = await response.json();
    if (response.ok) {
      const token = {
        email,
        token: json.access_token,
        refresh: json.refresh_token,
      };
      tokens[companyId] = token;
    } else {
      errorHandler(json.error_description);
    }
  });

  await Promise.all(promises);
  setBearerToken(tokens[selectedCompanyId]?.token);
}

export function getCompanyData(loginResponse) {
  const { companies, defaultCompanyId } = loginResponse;
  const needsCompanyChooser = !defaultCompanyId && companies.length !== 1;
  const unsortedCompanies = companies.map((company) => {
    return {
      id: company.companyId,
      userId: company.userId,
      name: company.companyName,
      accessToken: company.accessToken,
      accessTokenSecret: company.accessTokenSecret,
      expirationDate: company.expirationDate,
      userPrivileges: company.permissionsList,
      planLevel: company.planLevel,
      status: company.status,
      accountNumber: company.acctNumber,
      default: company.companyId === defaultCompanyId,
    };
  });

  const company = defaultCompanyId
    ? unsortedCompanies.find(({ id }) => id === defaultCompanyId)
    : unsortedCompanies[0];
  const sortedCompanies = unsortedCompanies.sort((a, b) =>
    a.name < b.name ? -1 : 1
  );

  return {
    selectedCompanyId: company.id,
    company,
    companies: sortedCompanies,
    needsCompanyChooser,
  };
}
